var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame399({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0761 16.2208L11.0556 14.2172C10.1271 13.2964 9.66271 12.8359 9.12812 12.6632C8.65788 12.5112 8.15177 12.5112 7.68144 12.6632C7.14688 12.8359 6.68255 13.2964 5.75391 14.2172L1.04933 18.9555M13.0761 16.2208L13.4776 15.8225C14.4259 14.8822 14.8999 14.4121 15.4439 14.2406C15.9222 14.0896 16.4362 14.0955 16.9111 14.2574C17.4508 14.4415 17.914 14.9224 18.8402 15.8841L19.8235 16.8825M13.0761 16.2208L17.7294 20.9562M1.04933 18.9555C1.08546 19.2619 1.14804 19.5025 1.25646 19.7153C1.48204 20.158 1.842 20.518 2.28473 20.7435C2.78805 21 3.44693 21 4.76471 21H16.0588C16.7898 21 17.318 21 17.7294 20.9562M1.04933 18.9555C1 18.5372 1 17.996 1 17.2353V5.94118C1 4.62341 1 3.96452 1.25646 3.4612C1.48204 3.01846 1.842 2.65851 2.28473 2.43293C2.78805 2.17647 3.44693 2.17647 4.76471 2.17647H9.23529M17.7294 20.9562C18.0596 20.9211 18.3147 20.8578 18.5388 20.7435C18.9815 20.518 19.3415 20.158 19.5671 19.7153C19.8235 19.212 19.8235 18.5531 19.8235 17.2353V12.7647M17.4706 8.05882V4.52941M17.4706 4.52941V1M17.4706 4.52941H21M17.4706 4.52941H13.9412",
    stroke: "#545454",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame399);
export default __webpack_public_path__ + "static/media/Frame 399.ae37c4b89a71739b0e3a5db7f3b6021a.svg";
export { ForwardRef as ReactComponent };